module.exports = __webpack_public_path__ + "images/frontpage_stars@3x.png?d754c8f0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_stars@3x.png
// module id = 665
// module chunks = 7